module.exports = __webpack_public_path__ + "static/media/4.99047ae2.png";